<template>
  <div class="home">
    <main>
      <Header />
      <Banner />
      <Posts />
      <Requisites />

      <div class="container">
        <div class="wrapper">
          <div class="container__inner">
            <div class="container__layout">
              <Speakers />

              <Program />
            </div>
          </div>
        </div>
      </div>

      <section class="banner">
        <div class="wrapper">
          <div class="banner__inner">
            <VolunteersBanner />
          </div>
        </div>
      </section>
    </main>
    <Footer />
    <Volunteers />
  </div>
</template>

<script>
import { Banner } from "@/components";
import { AuxiliaryHeader as Header } from "@/components/app/Headers";
import { VolunteersBanner } from "@/components/app/Banners";
import { Requisites, Posts, Speakers, Program } from "@/components/temp";

export default {
  name: "Serafim",
  data: () => ({
    loading: true
  }),
  components: {
    Header,
    Banner,
    Requisites,
    Posts,
    Speakers,
    Program,
    VolunteersBanner,
    Volunteers: () => import("@/components/app/Forms/Volunteers")
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.container {
  display: flex;
  justify-content: space-between;

  & .wrapper {
    width: 100%;
  }

  &__inner {
    padding: 40px 0;
  }

  &__layout {
    display: flex;
    flex-wrap: wrap;
  }

  &__speakers,
  &__program {
    padding: 30px 30px 60px;
  }

  @media screen and (min-width: $min-lg) {
    &__speakers,
    &__program {
      flex-basis: calc((100% / 2) - 15px);
      width: calc((100% / 2) - 15px);

      &:first-child {
        margin: 0 15px 0 0;
      }

      &:last-child {
        margin: 0 0 0 15px;
      }
    }
  }

  @media screen and (max-width: $max-md) {
    &__speakers,
    &__program {
      flex-basis: 100%;
      width: 100%;

      &:first-child {
        margin: 0 0 30px;
      }
    }
  }
}

.speakers,
.program {
  background-color: $sec_bg;
  border-radius: 30px;
  box-shadow: 0 0 2.5px 1px rgba($color: #000, $alpha: 0.1);

  &__title {
    margin: 0 0 30px;
    font-size: 26px;
  }
}

.banner .banner_serafim .banner,
.speakers {
  &__slider {
    position: relative;

    &-wrap {
      position: relative;
      margin: 0 auto;
      overflow: hidden;
    }

    &-track {
      display: flex;
      margin: 0 auto;
      transition: 0.4s;
    }
  }

  &__button {
    position: absolute;
    width: 40px;
    height: 40px;
    background-color: $sec_bg;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 1px 2px 1px rgba(#333, 0.1);
    outline: none;
    -webkit-tap-highlight-color: transparent;

    &_prev,
    &_next {
      top: 0;

      img {
        margin: auto;
      }
    }

    &_prev {
      left: 0;
    }
    &_next {
      right: 0;
    }

    &:focus {
      box-shadow: 0 0 1px 3px rgba($aux_bg, 0.5);
    }

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
